import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import MerchantSettlementComponent from "./views/MerchantSettlementList";

const MerchantSettlementList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <MerchantSettlementComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Merchant Settlement",
          description: "merchant settlement section"
        })}
      />
      <Routes>
        <Route path={""} element={<MerchantSettlementList />} />
      </Routes>
    </>
  );
};

export default Component;
